import { defineMessages } from 'react-intl';

export default defineMessages({
  //Communications table
  CommunicationsTableTitleLabel: {
    id: 'features.documentaArea.CommunicationsTableTitleLabel',
    defaultMessage: 'Titolo',
    description: 'Label for the title column in communications table',
  },

  CommunicationsTableDocumentTypeLabel: {
    id: 'features.documentaArea.CommunicationsTableDocumentTypeLabel',
    defaultMessage: 'Tipo documento',
    description: 'Label for the document type column in communications table',
  },

  CommunicationsTablePublicationDateLabel: {
    id: 'features.documentaArea.CommunicationsTablePublicationDateLabel',
    defaultMessage: 'Data pubblicazione',
    description:
      'Label for the pubblication date column in communications table',
  },

  CommunicationsTableJurisdictionDateLabel: {
    id: 'features.documentaArea.CommunicationsTableJurisdictionDateLabel',
    defaultMessage: 'Data competenza',
    description:
      'Label for the jurisdiction date column in communications table',
  },

  //Communications types
  CommunicationsTypeDailyAzfund: {
    id: 'features.documentaArea.CommunicationsTypeDailyAzfund',
    defaultMessage: 'AZFUND Giornaliere',
    description: 'Label for the communications daily azfund type',
  },

  CommunicationsTypeDailyBenefits: {
    id: 'features.documentaArea.CommunicationsTypeDailyBenefits',
    defaultMessage: 'Previdenza Giornaliere',
    description: 'Label for the communications daily benefits type',
  },

  CommunicationsTypeSemiannualAzfundOperationConfirmation: {
    id: 'features.documentaArea.CommunicationsTypeSemiannualAzfundOperationConfirmation',
    defaultMessage: 'Conferma Operazione AZFUND semestrale',
    description:
      'Label for the communications semiannual azfund operation confirmation type',
  },

  CommunicationsTypeDailyFundConfirmations: {
    id: 'features.documentaArea.CommunicationsTypeDailyFundConfirmations',
    defaultMessage: 'Conferme Giornaliere Fondi',
    description: 'Label for the communications daily fund confirmations type',
  },

  CommunicationsTypeAzSustainableFutureFundConfirmation: {
    id: 'features.documentaArea.CommunicationsTypeAZSustainableFutureFundConfirmation',
    defaultMessage: 'Conferma Fondo AZ Sustainable Future',
    description:
      'Label for the communications az sustainable future fund confirmation type',
  },

  CommunicationsTypeNewAssetManagementConfirmations: {
    id: 'features.documentaArea.CommunicationsTypeNewAssetManagementConfirmations',
    defaultMessage: 'Conferme Nuove Gestioni Patrimoniali',
    description:
      'Label for the communications new asset managemente confirmations type',
  },

  CommunicationsTypeDividendsLetter: {
    id: 'features.documentaArea.CommunicationsTypeDividendsLetter',
    defaultMessage: 'Lettera dividendi',
    description: 'Label for the communications dividends letter type',
  },

  CommunicationsTypeDividendReinvestmentConfirmation: {
    id: 'features.documentaArea.CommunicationsTypeDividendReinvestmentConfirmation',
    defaultMessage: 'Conferma Reinvestimento Dividendi',
    description:
      'Label for the communications dividend reinvestment confirmation type',
  },

  CommunicationsTypeAfiServiceWelcomeLetterAddendum: {
    id: 'features.documentaArea.CommunicationsTypeAfiServiceWelcomeLetterAddendum',
    defaultMessage: 'Lettera di benvenuto Servizio AFI - Addendum',
    description:
      'Label for the communications afi service welcome letter addendum type',
  },

  CommunicationsTypeWelcomeLetterMaxService: {
    id: 'features.documentaArea.CommunicationsTypeWelcomeLetterMaxService',
    defaultMessage: 'Lettera di benvenuto Servizio MAX',
    description: 'Label for the communications welcome letter max service type',
  },

  CommunicationsTypeWelcomeLetterPirService: {
    id: 'features.documentaArea.CommunicationsTypeWelcomeLetterPirService',
    defaultMessage: 'Lettera di benvenuto Servizio PIR',
    description: 'Label for the communications welcome letter pir service',
  },

  CommunicationsTypeAfiWelcomeLetter: {
    id: 'features.documentaArea.CommunicationsTypeAfiWelcomeLetter',
    defaultMessage: 'Lettera di benvenuto AFI',
    description: 'Label for the communications afi welcome letter type',
  },

  CommunicationsTypeWelcomeLetterSgr: {
    id: 'features.documentaArea.CommunicationsTypeWelcomeLetterSgr',
    defaultMessage: 'Lettera di benvenuto Sgr',
    description: 'Label for the communications welcome letter sgr type',
  },

  CommunicationsTypeWelcomeLetterGoalBasedPlan: {
    id: 'features.documentaArea.CommunicationsTypeWelcomeLetterGoalBasedPlan',
    defaultMessage: 'Lettera di benvenuto Servizio Goal Based Plan',
    description:
      'Label for the communications welcome letter goal based plan type',
  },

  CommunicationsTypeWelcomeLetterNga: {
    id: 'features.documentaArea.CommunicationsTypeWelcomeLetterNga',
    defaultMessage: 'Lettera di benvenuto NGA',
    description: 'Label for the communications welcome letter nga type',
  },
  CommunicationsTypeWelcomeLetterNgaSmart: {
    id: 'features.documentaArea.CommunicationsTypeWelcomeLetterNgaSmart',
    defaultMessage: 'Lettera di benvenuto NGA Smart',
    description: 'Label for the communications welcome letter nga smart type',
  },
  CommunicationsTypeWelcomeLetterMonoNgaSmart: {
    id: 'features.documentaArea.CommunicationsTypeWelcomeLetterMonoNgaSmart',
    defaultMessage: 'Lettera di benvenuto NGA Smart',
    description:
      'Label for the communications welcome letter mono nga smart type',
  },
  CommunicationsTypeWelcomeLetterMonoNgaFull: {
    id: 'features.documentaArea.CommunicationsTypeWelcomeLetterMonoNgaFull',
    defaultMessage: 'Lettera di benvenuto NGA',
    description:
      'Label for the communications welcome letter mono nga full type',
  },
  CommunicationsTypeWelcomeLetterMonoMax: {
    id: 'features.documentaArea.CommunicationsTypeWelcomeLetterMonoMax',
    defaultMessage: 'Lettera di benvenuto Servizio MAX',
    description: 'Label for the communications welcome letter mono max type',
  },

  CommunicationsTypeMifidRelevantLossesAdministered: {
    id: 'features.documentaArea.CommunicationsTypeMifidRelevantLossesAdministered',
    defaultMessage: 'Perdite rilevanti MiFID - Amministrato',
    description:
      'Label for the communications mifid relevant losses administered type',
  },

  CommunicationsTypeMifidRelevantLossesManagement: {
    id: 'features.documentaArea.CommunicationsTypeMifidRelevantLossesManagement',
    defaultMessage: 'Perdite rilevanti MiFID - Gestioni',
    description:
      'Label for the communications mifid relevant losses management type',
  },

  CommunicationsTypeInformationNotes: {
    id: 'features.documentaArea.CommunicationsTypeInformationNotes',
    defaultMessage: 'Note informative',
    description: 'Label for the communications information notes type',
  },
  CommunicationsTypeReport: {
    id: 'features.documentaArea.CommunicationsTypeReport',
    defaultMessage: 'Rendicontazione',
    description: 'Label for the communications report',
  },
  CommunicationsTypeThirdPartyShareholders: {
    id: 'features.documentaArea.CommunicationsTypeThirdPartyShareholders',
    defaultMessage: 'Comunicazioni az. case terze',
    description: 'Label for the communications third party shareholders',
  },
  CommunicationsTypeDailyThirdParty: {
    id: 'features.documentaArea.CommunicationsTypeDailyThirdParty',
    defaultMessage: 'Case terze giornaliere',
    description: 'Label for the daily third party communications',
  },
  CommunicationsTypeMontiStampDutyOrderConfirmation: {
    id: 'features.documentaArea.CommunicationsTypeMontiStampDutyOrderConfirmation',
    defaultMessage: "Lettere conferma d' ordine bollo Monti",
    description:
      'Label for the Monti stamp duty order confirmation communications',
  },
  CommunicationsTypeCorporateActionRto: {
    id: 'features.documentaArea.CommunicationsTypeCorporateActionRto',
    defaultMessage: 'Corporate Action RTO',
    description: 'Label for the Corporate Action RTO communications',
  },
  CommunicationsTypeLetterAdvExpired: {
    id: 'features.documentaArea.CommunicationsTypeCorporateActionRto',
    defaultMessage: 'Lettera ADV Scaduta',
    description: 'Label for the Letter ADV Expired',
  },
  CommunicationsTypeLetterAdvToBeExpired: {
    id: 'features.documentaArea.CommunicationsTypeCorporateActionRto',
    defaultMessage: 'Lettera ADV In Scadenza',
    description: 'Label for the Letter ADV To Be Expired',
  },
  CommunicationsTypeDistribuzioneDividendi: {
    id: 'features.documentaArea.CommunicationsTypeDistribuzioneDividendi',
    defaultMessage: 'Distribuzione Dividendi',
    description: 'Label for DISTRIBUZIONE_DIVIDENDI',
  },
  CommunicationsTypeDistribuzioneProventi: {
    id: 'features.documentaArea.CommunicationsTypeDistribuzioneProventi',
    defaultMessage: 'Distribuzione Proventi',
    description: 'Label for DISTRIBUZIONE_PROVENTI',
  },
  CommunicationsTypeDistribuzioneProventiGalaxy: {
    id: 'features.documentaArea.CommunicationsTypeDistribuzioneProventiGalaxy',
    defaultMessage: 'Distribuzione Proventi Galaxy',
    description: 'Label for DISTRIBUZIONE_PROVENTI_GALAXY',
  },
  CommunicationsTypeLetteraRimborsoFiaCapitaleAli: {
    id: 'features.documentaArea.CommunicationsTypeLetteraRimborsoFiaCapitaleAli',
    defaultMessage: 'Lettera Rimborso FIA Capitale ALI',
    description: 'Label for LETTERA_RIMBORSO_FIA_CAPITALE_ALI',
  },
  CommunicationsTypeLetteraRimborsoFiaCapitaleAcm: {
    id: 'features.documentaArea.CommunicationsTypeLetteraRimborsoFiaCapitaleAcm',
    defaultMessage: 'Lettera Rimborso FIA Capitale ACM',
    description: 'Label for LETTERA_RIMBORSO_FIA_CAPITALE_ACM',
  },
  CommunicationsTypeLetteraRimborsoFiaProventoAli: {
    id: 'features.documentaArea.CommunicationsTypeLetteraRimborsoFiaProventoAli',
    defaultMessage: 'Lettera Rimborso FIA Provento ALI',
    description: 'Label for LETTERA_RIMBORSO_FIA_PROVENTO_ALI',
  },
  CommunicationsTypeLetteraRimborsoFiaProventoAcm: {
    id: 'features.documentaArea.CommunicationsTypeLetteraRimborsoFiaProventoAcm',
    defaultMessage: 'Lettera Rimborso FIA Provento ACM',
    description: 'Label for LETTERA_RIMBORSO_FIA_PROVENTO_ACM',
  },
    CommunicationTypeLetteraRimborsoProventoAli: {
    id: 'features.documentaArea.CommunicationTypeLetteraRimborsoProventoAli',
    defaultMessage: 'Lettera Rimborso Provento ALI',
    description: 'Label for LETTERA_RIMBORSO_PROVENTO_ALI',
  },
  CommunicationTypeLetteraRimborsoProventoAcm: {
    id: 'features.documentaArea.CommunicationTypeLetteraRimborsoProventoAcm',
    defaultMessage: 'Lettera Rimborso Provento ACM',
    description: 'Label for LETTERA_RIMBORSO_PROVENTO_ACM',
  },
  CommunicationsTypeLetteraRichiamoFiaProdPirDescAcm: {
    id: 'features.documentaArea.CommunicationsTypeLetteraRichiamoFiaProdPirDescAcm',
    defaultMessage: 'Lettera Richiamo FIA Prod PIR Desc ACM',
    description: 'Label for LETTERA_RICHIAMO_FIA_PROD_PIR_DESC_ACM',
  },
  CommunicationsTypeLetteraRichiamoFiaProdPirDescAli: {
    id: 'features.documentaArea.CommunicationsTypeLetteraRichiamoFiaProdPirDescAli',
    defaultMessage: 'Lettera Richiamo FIA Prod PIR Desc ALI',
    description: 'Label for LETTERA_RICHIAMO_FIA_PROD_PIR_DESC_ALI',
  },

  CommunicationsTypeLetteraRichiamoFiaMultirichiamoAli: {
    id: 'features.documentaArea.CommunicationsTypeLetteraRichiamoFiaMultirichiamoAli',
    defaultMessage: 'Lettera Richiamo FIA Multirichiamo ALI',
    description: 'Label for LETTERA_RICHIAMO_FIA_MULTIRICHIAMO_ALI',
  },
  CommunicationsTypeLetteraRichiamoFiaMultirichiamoAcm: {
    id: 'features.documentaArea.CommunicationsTypeLetteraRichiamoFiaMultirichiamoAcm',
    defaultMessage: 'Lettera Richiamo FIA Multirichiamo ACM',
    description: 'Label for LETTERA_RICHIAMO_FIA_MULTIRICHIAMO_ACM',
  },

  CommunicationsTypeLetteraConfermaFiaPagamentoAli: {
    id: 'features.documentaArea.CommunicationsTypeLetteraConfermaFiaPagamentoAli',
    defaultMessage: 'Lettera Conferma FIA Pagamento ALI',
    description: 'Label for LETTERA_CONFERMA_FIA_PAGAMENTO_ALI',
  },
  CommunicationsTypeLetteraConfermaFiaPagamentoAcm: {
    id: 'features.documentaArea.CommunicationsTypeLetteraConfermaFiaPagamentoAcm',
    defaultMessage: 'Lettera Conferma FIA Pagamento ACM',
    description: 'Label for LETTERA_CONFERMA_FIA_PAGAMENTO_ACM',
  },
  CommunicationsTypeLetteraFiaCertificazioneMinusvalenzeAli: {
    id: 'features.documentaArea.CommunicationsTypeLetteraFiaCertificazioneMinusvalenzeAli',
    defaultMessage: 'Lettera FIA Certificazione Minusvalenze ALI',
    description: 'Label for LETTERA_FIA_CERTIFICAZIONE_MINUSVALENZE_ALI',
  },
  CommunicationsTypeLetteraFiaCertificazioneMinusvalenzeAcm: {
    id: 'features.documentaArea.CommunicationsTypeLetteraFiaCertificazioneMinusvalenzeAcm',
    defaultMessage: 'Lettera FIA Certificazione Minusvalenze ACM',
    description: 'Label for LETTERA_FIA_CERTIFICAZIONE_MINUSVALENZE_ACM',
  },
  CommunicationsTypeLetteraTrasferimentoFiaErediAli: {
    id: 'features.documentaArea.CommunicationsTypeLetteraTrasferimentoFiaErediAli',
    defaultMessage: 'Lettera Trasferimento FIA Eredi ALI',
    description: 'Label for LETTERA_TRASFERIMENTO_FIA_EREDI_ALI',
  },
  CommunicationsTypeLetteraTrasferimentoFiaErediAcm: {
    id: 'features.documentaArea.CommunicationsTypeLetteraTrasferimentoFiaErediAcm',
    defaultMessage: 'Lettera Trasferimento FIA Eredi ACM',
    description: 'Label for LETTERA_TRASFERIMENTO_FIA_EREDI_ACM',
  },
  CommunicationsTypeLetteraIstruzioneProventoRto: {
    id: 'features.documentaArea.CommunicationsTypeLetteraIstruzioneProventoRto',
    defaultMessage: 'Lettera Istruzione Provento RTO',
    description: 'Label for LETTERA_ISTRUZIONE_PROVENTO_RTO',
  },
  CommunicationsTypeLetteraIstruzioneProventoEy: {
    id: 'features.documentaArea.CommunicationsTypeLetteraIstruzioneProventoEy',
    defaultMessage: 'Lettera Istruzione Provento EY',
    description: 'Label for LETTERA_ISTRUZIONE_PROVENTO_EY',
  },
  CommunicationsTypeNews: {
    id: 'features.documentaArea.CommunicationsTypeNews',
    defaultMessage: 'News',
    description: 'Label for NEWS',
  },
  CommunicationsTypeVariazioneOffertaFondi: {
    id: 'features.documentaArea.CommunicationsTypeVariazioneOffertaFondi',
    defaultMessage: 'Variazione Offerta Fondi',
    description: 'Label for VARIAZIONE_OFFERTA_FONDI',
  },
  CommunicationsTypeVariazioneUnilaterale: {
    id: 'features.documentaArea.CommunicationsTypeVariazioneUnilaterale',
    defaultMessage: 'Variazione Unilaterale',
    description: 'Label for VARIAZIONE_UNILATERALE',
  },
});
